'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.xhrImpl = xhrImpl;

var _getBoundary = require('./getBoundary');

var _PatchResolver = require('./PatchResolver');

function supportsXhrResponseType(type) {
    try {
        var tmpXhr = new XMLHttpRequest();
        tmpXhr.responseType = type;
        return tmpXhr.responseType === type;
    } catch (e) {
        /* IE throws on setting responseType to an unsupported value */
    }
    return false;
}

function xhrImpl(url, _ref) {
    var method = _ref.method,
        headers = _ref.headers,
        credentials = _ref.credentials,
        body = _ref.body,
        onNext = _ref.onNext,
        onError = _ref.onError,
        onComplete = _ref.onComplete;

    var xhr = new XMLHttpRequest();
    xhr.withCredentials = credentials === 'include'; // follow behavior of fetch credentials param https://github.com/github/fetch#sending-cookies
    var index = 0;
    var isDeferred = false;
    var boundary = void 0;
    var patchResolver = void 0;

    function onReadyStateChange() {
        // The request failed, do nothing and let the error event fire
        if (this.readyState === this.DONE && this.status === 0) {
            return;
        }

        if (this.readyState === this.HEADERS_RECEIVED) {
            var contentType = xhr.getResponseHeader('Content-Type');
            if (contentType.indexOf('multipart/mixed') >= 0) {
                isDeferred = true;
                boundary = (0, _getBoundary.getBoundary)(contentType);
                patchResolver = new _PatchResolver.PatchResolver({ onResponse: function onResponse(r) {
                        return onNext(r, {});
                    }, boundary: boundary });
            }
        } else if ((this.readyState === this.LOADING || this.readyState === this.DONE) && isDeferred) {
            var chunk = xhr.response.substr(index);
            patchResolver.handleChunk(chunk);
            index = xhr.responseText.length;
        } else if (this.readyState === this.DONE && !isDeferred) {
            onNext([JSON.parse(xhr.response)], {});
            onComplete();
        }
    }

    function onLoadEvent() {
        onComplete();
    }

    function onErrorEvent(err) {
        onError(err);
    }

    xhr.open(method, url);

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.entries(headers)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref2 = _step.value;

            var _ref3 = _slicedToArray(_ref2, 2);

            var header = _ref3[0];
            var value = _ref3[1];

            if (header !== 'referer') {
                xhr.setRequestHeader(header, value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    if (supportsXhrResponseType('moz-chunked-text')) {
        xhr.responseType = 'moz-chunked-text';
    }

    xhr.addEventListener('readystatechange', onReadyStateChange);
    xhr.addEventListener('loaded', onLoadEvent);
    xhr.addEventListener('error', onErrorEvent);
    xhr.send(body);
}